"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var context_1 = require("../store/context");
var store_1 = __importDefault(require("../store/store"));
var styles = __importStar(require("./styles"));
var Console = function () {
    var _a = (0, context_1.useStore)(), setDebuggerProp = _a.setDebuggerProp, debuggerProps = _a.debuggerProps;
    var _b = (0, react_1.useState)(false), isOpen = _b[0], setIsOpen = _b[1];
    var handleToggleClick = function () {
        setIsOpen(function (open) { return !open; });
    };
    var handlePropertyChange = function (e, key) {
        var value = e.currentTarget.value;
        setDebuggerProp({ key: key, value: value });
    };
    if (!debuggerProps.length)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(store_1.default, null,
            react_1.default.createElement("button", { style: styles.button, type: "button", onClick: handleToggleClick }, "" + (!isOpen ? 'Open' : 'Close')),
            isOpen && (react_1.default.createElement("div", { style: styles.consoleWrapper }, debuggerProps.sort(function (a, b) { return ((a.key < b.key) ? 1 : -1); })
                .map(function (debugProp) { return (react_1.default.createElement("div", { style: styles.debugProp, key: debugProp.key },
                react_1.default.createElement("div", { style: styles.hookLabel }, debugProp.key),
                react_1.default.createElement("input", { style: styles.hookInput, value: debugProp.value, onChange: function (e) { return handlePropertyChange(e, debugProp.key); } }))); }))))));
};
exports.default = Console;
//# sourceMappingURL=index.js.map